"use strict";

// Document ready
document.addEventListener("DOMContentLoaded", function () {
  // cookie statement
  var ktCookieStatementContainer = document.querySelector("#ktCookieStatementContainer");

  if (ktCookieStatementContainer && ktCookieStatementContainer.length !== null) {
    if (!checkCookieRecord("kt-cookie-statement-key")) {
      document.querySelector("#ktCookieStatement").style.display = "flex";
    } // Conset to allow cookies


    var cookiesConsentButton = document.querySelector("#ktCookieStatementConfirm");

    if (cookiesConsentButton && cookiesConsentButton.length !== null) {
      cookiesConsentButton.addEventListener("click", function () {
        setCookieRecord("kt-cookie-statement-key", 1, 10);
        document.querySelector("#ktCookieStatement").style.display = "none";
      });
    }
  }
}); // Nastaví cookie hodnotu dle klíče po zadanou dobu (pro celou cestu /)

function setCookieRecord(cookieName, cookieValue, expirationDaysCount) {
  var date = new Date();
  date.setFullYear(date.getFullYear() + expirationDaysCount);
  document.cookie = cookieName + "=" + cookieValue + "; path=/; expires=" + date.toUTCString();
} // Smaže cookie hodnotu dle klíče po zadanou dobu (pro celou cestu /)


function removeCookieRecord(cookieName) {
  var date = new Date();
  date.setFullYear(date.getFullYear() - 1);
  document.cookie = cookieName + '=""; path=/; expires=' + date.toUTCString();
} // Vrátí hodnotu cookie dle klíče


function getCookieRecord(cookieName) {
  var name = cookieName + "=";
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookieValue = cookies[i];

    while (cookieValue.charAt(0) == " ") {
      cookieValue = cookieValue.substring(1);
    }

    if (cookieValue.indexOf(name) == 0) {
      return cookieValue.substring(name.length, cookieValue.length);
    }
  }

  return "";
} // Zkontroluje, zda existuje cookie (hodnota dle klíče)


function checkCookieRecord(cookieName) {
  var cookieValue = getCookieRecord(cookieName);

  if (cookieValue != "") {
    return true;
  }

  return false;
} // Odstraní z URL parametr a jeho hodnotu


function removeUrlParameter(parameter) {
  var url = document.location.href;
  var urlParts = url.split("?");

  if (urlParts.length >= 2) {
    var urlBase = urlParts.shift();
    var queryString = urlParts.join("?");
    var prefix = encodeURIComponent(parameter) + "=";
    var parts = queryString.split(/[&;]/g);

    for (var i = parts.length; i-- > 0;) {
      if (parts[i].lastIndexOf(prefix, 0) !== -1) {
        parts.splice(i, 1);
      }
    }

    url = urlBase + "?" + parts.join("&");
    window.history.pushState("", document.title, url);
  }

  return url;
} // Vrátí hodnotu parametru z URL podle jeho klíče (názvu)
// BUJS #1 – getParameterByName by James Padolsey (http://james.padolsey.com/javascript/bujs-1-getparameterbyname/)


function getUrlParameterValue(key) {
  var match = RegExp("[?&]" + key + "=([^&]*)").exec(window.location.search);
  return match && decodeURIComponent(match[1].replace("/+/g", " "));
} // Vrátí hodnotu parametru z URL podle jeho klíče (názvu)
// add or update query string parameter by Niyaz (http://stackoverflow.com/a/6021027)


function addOrUpdateUrlParameterValue(key, value) {
  var url = window.location.href;
  var regExp = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = url.indexOf("?") !== -1 ? "&" : "?";

  if (url.match(regExp)) {
    window.history.pushState({}, null, url.replace(regExp, "$1" + key + "=" + value + "$2"));
  } else {
    window.history.pushState({}, null, url + separator + key + "=" + value);
  }
} // $(document).ready(function () {
//   // Validování formuláře pomocí jQuery globálně na základě data attributu, který vpisován defaulntě KT_Form třídou
//   $('[data-validate="jquery"]').submit(function () {
//     $(".validator").remove();
//     $("#jquery-kt-validator").remove();
//     var showNotice = $(this).data("show-notice");
//     var validationResult = $(this).formValidation();
//     return validationResult;
//   });
//   $("input.kt-field, textarea.kt-field").click(function () {
//     $(this)
//       .next("div.validator")
//       .remove();
//   });
//   $("body").on("click", "div.validator", function () {
//     $(this).remove();
//   });
//   $("input").on("input", function () {
//     $(this)
//       .siblings(".validator")
//       .remove();
//   });
// });
// (function ($) {
//   /**
//    * jQueryś plugin pro validaci KT_Form na straně browseru
//    *
//    * @author Tomáš Kocifaj
//    * @link http://www.ktstudio.cz
//    *
//    * @returns {Boolean}
//    */
//   $.fn.formValidation = function () {
//     var dataValidators = "validators";
//     var isValid = true;
//     var methods = {
//       validate: function (element) {
//         var validators = element.data(dataValidators);
//         for (var index in validators) {
//           var currentValidator = validators[index];
//           var validatorFunction = currentValidator.condition;
//           if (currentValidator.condition !== "required" && element.val() === "") {
//             continue;
//           }
//           var result = methods[validatorFunction](element.val(), currentValidator.params);
//           if (result === false) {
//             element.after(methods.errorMsgContent(currentValidator.msg));
//             isValid = false;
//             return;
//           }
//         }
//       },
//       // validační funkce na základě předané hodnoty
//       required: function (value, param) {
//         if (value !== "") {
//           return true;
//         }
//         return false;
//       },
//       integer: function (value, param) {
//         return value % 1 === 0;
//       },
//       float: function (value, param) {
//         var RE = /^-{0,1}\d*\.{0,1}\d+$/;
//         return RE.test(value);
//       },
//       email: function (value, param) {
//         var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
//         return regex.test(value);
//       },
//       url: function (value) {
//         var regexp = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
//         return regexp.test(value);
//       },
//       range: function (value, param) {
//         console.log(!methods.float(value));
//         if (!methods.float(value)) {
//           return false;
//         }
//         var minValue = parseInt(param[0]);
//         var maxValue = parseInt(param[1]);
//         if (value >= minValue && value <= maxValue) {
//           return true;
//         }
//         return false;
//       },
//       length: function (value, param) {
//         if (value.length === param) {
//           return true;
//         }
//         return false;
//       },
//       maxLength: function (value, param) {
//         if (value.length <= param) {
//           return true;
//         }
//         return false;
//       },
//       minLength: function (value, param) {
//         if (value.length >= param) {
//           return true;
//         }
//         return false;
//       },
//       maxNumber: function (value, param) {
//         if (!methods.float(value)) {
//           return false;
//         }
//         value = parseInt(value);
//         if (value <= param) {
//           return true;
//         }
//         return false;
//       },
//       minNumber: function (value, param) {
//         if (!methods.float(value)) {
//           return false;
//         }
//         value = parseInt(value);
//         if (value >= param) {
//           return true;
//         }
//         return false;
//       },
//       regular: function (value, param) {
//         var patt = new RegExp(param);
//         return patt.test(value);
//       },
//       // funkce vrátím HTML s chybovou hláškou na základě předané MSG
//       errorMsgContent: function (msg) {
//         var html = '<div class="validator">' + '<span class="erorr-s">' + msg + "</span>" + "</div>";
//         return html;
//       }
//     };
//     $(this)
//       .find("[data-" + dataValidators + "]")
//       .each(function () {
//         methods.validate($(this));
//       });
//     return isValid;
//   };
// })($);
// Document ready


document.addEventListener("DOMContentLoaded", function () {
  LazyLoadingInit();
}); // Lazy loading Init

function LazyLoadingInit() {
  var myLazyLoad = new LazyLoad({
    elements_selector: "[data-src], [data-bg]",
    threshold: 400,
    callback_set: function callback_set(el) {
      objectFitImages(el);
    }
  }); // $(document).ajaxComplete(function () {
  //   myLazyLoad.update();
  // });
}

var brilo = function () {
  return {
    // Px to Rem conversion
    pxToRem: function pxToRem(value) {
      var rootFontSize = 16;
      value = value / rootFontSize;
      value = value.toFixed(3);
      return value;
    }
  };
}(); // Document ready


document.addEventListener("DOMContentLoaded", function () {
  scrollTriggers();
  backToTop();
}); // Funkce pro animované posunutí na prvek v DOM dokumentu

function moveToHtmlTarget(elemnt, topOffset, bottomOffset) {
  var offset = elemnt.offsetTop;

  if (topOffset > 0) {
    offset = offset - topOffset;
  }

  if (bottomOffset > 0) {
    offset = offset + bottomOffset;
  }

  window.scrollTo({
    behavior: 'smooth',
    left: 0,
    top: offset
  });
  return this;
}

function scrollTriggers() {
  var scrollTrigger = document.querySelectorAll(".scroll-trigger");
  var i; // Button--------------

  for (i = 0; i < scrollTrigger.length; i++) {
    scrollTrigger[i].addEventListener("click", function () {
      var sectionId = this.getAttribute("data-id-section");
      var topOfSection = document.querySelector("#" + sectionId);
      var topOfSectionPx = topOfSection.offsetTop;
      var isIE = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;

      if (isIE) {
        window.scrollTo(0, topOfSectionPx);
      } else {
        topOfSection.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  }
} //BACT TO TOP BUTTON----------------------------------


function backToTop() {
  var backToTopButton = document.querySelectorAll(".scroll-top");

  for (var _i = 0; _i < backToTopButton.length; _i++) {
    if (backToTopButton[_i] != null) {
      (function () {
        var toTop = function toTop() {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
          });
        };

        backToTopButton[_i].addEventListener("click", function () {
          toTop();
        });
      })();
    }
  }
} // // Document ready
// document.addEventListener("DOMContentLoaded", function () {
//   submitFormOnFakeButton();
//   preventDefaultUtil();
//   moveToHtmlTargetInit();
// });
// //Submit form with fake button
// function submitFormOnFakeButton() {
//   $("#submitButton, .submitButton").click(function () {
//     if ($(this).hasClass("disabled")) {
//       return false;
//     }
//     $(this)
//       .parents("form")
//       .submit();
//   });
// }
// //Prevent Default
// function preventDefaultUtil() {
//   var preventDefaultItems = document.querySelectorAll(".js-prevent-default"),
//     i;
//   if (preventDefaultItems[0] != undefined) {
//     for (i = 0; i < preventDefaultItems.length; ++i) {
//       preventDefaultItems[i].addEventListener("click", function (e) {
//         e.preventDefault();
//       });
//     }
//   }
// }
// function moveToHtmlTargetInit() {
//   $("[data-kt-target]").click(function () {
//     var targetElement = $($(this).data("kt-target"));
//     var targetBottomOffset = $(this).data("kt-bottom-offset");
//     var targetTopOffset = $(this).data("kt-top-offset");
//     moveToHtmlTarget(targetElement, targetTopOffset, targetBottomOffset);
//   });
// }


(function () {
  //Document ready
  document.addEventListener("DOMContentLoaded", function () {
    asideNavMobile();
  }); //Resize

  window.addEventListener("resize", function () {
    if (window.matchMedia("(min-width: 62em)").matches) {
      asideNavResizeReset();
    }
  }); //Functions

  function asideNavMobile() {
    var widgetCategoriesTitle = document.querySelectorAll(".widget_categories .widgettitle");

    if (widgetCategoriesTitle) {
      var _loop = function _loop(_i2) {
        var category = widgetCategoriesTitle[_i2];
        category.addEventListener("click", function () {
          //Up to tablet portrait - up to 991px
          if (window.matchMedia("(max-width: 61.938em)").matches) {
            category.classList.toggle("js-open");

            if (category.parentNode.querySelector("ul")) {
              category.parentNode.querySelector("ul").classList.toggle("js-open");
            }

            if (category.parentNode.querySelector("form")) {
              category.parentNode.querySelector("form").classList.toggle("js-open");
            }
          }
        });
      };

      for (var _i2 = 0; _i2 < widgetCategoriesTitle.length; _i2++) {
        _loop(_i2);
      }
    }

    ;
    var widgetNavmMenu = document.querySelectorAll(".widget_nav_menu .widgettitle");

    if (widgetNavmMenu) {
      var _loop2 = function _loop2(_i3) {
        var navMenu = widgetNavmMenu[_i3];
        navMenu.addEventListener("click", function () {
          //Up to tablet portrait - up to 991px
          if (window.matchMedia("(max-width: 61.938em)").matches) {
            navMenu.classList.toggle("js-open");
            navMenu.parentNode.querySelector("ul").classList.toggle("js-open");
          }
        });
      };

      for (var _i3 = 0; _i3 < widgetNavmMenu.length; _i3++) {
        _loop2(_i3);
      }
    }

    ;
    var widgetPages = document.querySelectorAll(".widget_pages .widgettitle");

    if (widgetPages) {
      var _loop3 = function _loop3(_i4) {
        var page = widgetPages[_i4];
        page.addEventListener("click", function () {
          //Up to tablet portrait - up to 991px
          if (window.matchMedia("(max-width: 61.938em)").matches) {
            page.classList.toggle("js-open");
            page.parentNode.querySelector("ul").classList.toggle("js-open");
          }
        });
      };

      for (var _i4 = 0; _i4 < widgetPages.length; _i4++) {
        _loop3(_i4);
      }
    }

    ;
  }

  function asideNavResizeReset() {
    var widgetCategoriesTitle = document.querySelectorAll(".widget_categories .widgettitle");

    if (widgetCategoriesTitle) {
      for (var _i5 = 0; _i5 < widgetCategoriesTitle.length; _i5++) {
        var category = widgetCategoriesTitle[_i5];

        if (category.classList.contains("js-open")) {
          category.classList.remove("js-open");
        }

        if (category.parentNode.querySelector("ul") && category.parentNode.querySelector("ul").classList.contains("js-open")) {
          category.parentNode.querySelector("ul").classList.remove("js-open");
        }

        if (category.parentNode.querySelector("form")) {
          if (category.parentNode.querySelector("form").classList.contains("js-open")) {
            category.parentNode.querySelector("form").classList.remove("js-open");
          }
        }
      }
    }

    ;
    var widgetNavmMenu = document.querySelectorAll(".widget_nav_menu .widgettitle");

    if (widgetNavmMenu) {
      for (var _i6 = 0; _i6 < widgetNavmMenu.length; _i6++) {
        var navMenu = widgetNavmMenu[_i6];

        if (navMenu.classList.contains("js-open")) {
          navMenu.classList.remove("js-open");
        }

        if (navMenu.parentNode.querySelector("ul") && navMenu.parentNode.querySelector("ul").classList.contains("js-open")) {
          navMenu.parentNode.querySelector("ul").classList.remove("js-open");
        }
      }
    }

    ;
    var widgetPages = document.querySelectorAll(".widget_pages .widgettitle");

    if (widgetPages) {
      for (var _i7 = 0; _i7 < widgetPages.length; _i7++) {
        var page = widgetPages[_i7];

        if (page.classList.contains("js-open")) {
          page.classList.remove("js-open");
        }

        if (page.parentNode.querySelector("ul") && page.parentNode.querySelector("ul").classList.contains("js-open")) {
          page.parentNode.querySelector("ul").classList.remove("js-open");
        }
      }
    }

    ;
  }
})();

(function () {
  //Document ready
  document.addEventListener("DOMContentLoaded", function () {
    fakePlaceholder();
  }); //Fake placeholder

  function fakePlaceholder() {
    var formInputs = document.querySelectorAll(".contact-form-top input"),
        i;

    for (i = 0; i < formInputs.length; ++i) {
      formInputs[i].addEventListener("focusin", function () {
        placeholderSetActive(this);
      }, false);
      formInputs[i].addEventListener("focusout", function () {
        placeholderSetPassive(this);
      }, false);
    }
  } //Placeholder set active


  function placeholderSetActive(input) {
    input.parentNode.querySelector(".fake-placeholder").classList.add("js-active");
  } //Placeholder set passive


  function placeholderSetPassive(input) {
    if (input.value === "") {
      input.parentNode.querySelector(".fake-placeholder").classList.remove("js-active");
    }
  }
})();

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    setData();
    monitoringClickOnLabel();
    addPoint();
    removePoint();
    checkInputChange();
    stickyConfigResultPosition();
    window.addEventListener('resize', function () {
      window.addEventListener('scroll', function () {
        stickyConfigResultPosition();
      });
    });
    window.addEventListener('scroll', function () {
      stickyConfigResultPosition();
    });
  }); //function for monitoring of used points

  function monitoringOfUsedPoints() {
    var configuratiorSection = document.querySelector(".configurator-section");
    var totalPoins = configuratiorSection.querySelector(".total-used-points .total-points");
    totalPoins = parseInt(totalPoins.textContent);
    var data = dataBriloWeb;
    var radiantMaxPoint = parseInt(data.radiant.maxPoints);
    var emeraldMaxPoint = parseInt(data.emerald.maxPoints);

    if (0 < totalPoins) {
      if (totalPoins <= radiantMaxPoint) {
        configuratiorSection.querySelector("#radiant").checked = true;
      } else {
        if (totalPoins <= emeraldMaxPoint) {
          configuratiorSection.querySelector("#emerald").checked = true;
        } else {
          configuratiorSection.querySelector("#briliant").checked = true;
        }
      }
    } else {
      if (configuratiorSection.querySelector("#custom")) {
        configuratiorSection.querySelector("#custom").checked = true;
      }
    } //Up to tablet portrait - up to 991px


    if (window.matchMedia("(max-width: 61.938em)").matches) {
      productItemWidth();
    }
  } //function for monitoring checked click on label


  function monitoringClickOnLabel() {
    var configuratiorSection = document.querySelector(".configurator-section");

    if (!configuratiorSection) {
      return;
    }

    var labels = configuratiorSection.querySelectorAll("label");

    for (var _i8 = 0; _i8 < labels.length; _i8++) {
      labels[_i8].addEventListener("mousedown", function (e) {
        //vypíše puvodní input
        var checkedInput = configuratiorSection.querySelector("input:checked");
        var checkedInputID = checkedInput.id; //vypíše na co bylo kliknuto

        var targetElement = e.target;
        var labelchecked = targetElement.parentNode.querySelector("input").id;
        checkConformity(checkedInputID, labelchecked); //Up to tablet portrait - up to 991px

        if (window.matchMedia("(max-width: 61.938em)").matches) {
          widthAfterCheckInput();
        }
      });
    }
  } //function for setting datas from json


  function setData() {
    var configuratiorSection = document.querySelector(".configurator-section");

    if (!configuratiorSection) {
      return;
    }

    var data = dataBriloWeb;
    var checkedInput = configuratiorSection.querySelector("input:checked");
    var checkedInputID = checkedInput.id;
    var featureItemsVariables = data[checkedInputID];
    var featureItems = configuratiorSection.querySelectorAll(".features-list .feature-item input");

    for (var _i9 = 0; _i9 < featureItems.length; _i9++) {
      featureItems[_i9].value = featureItemsVariables[_i9];
    }

    configPointsCalc();
  } //function for add point to input in configurator


  function addPoint() {
    var configuratiorSection = document.querySelector(".configurator-section");

    if (!configuratiorSection) {
      return;
    }

    var plusButtons = configuratiorSection.querySelectorAll(".features-list .feature-item .button-plus");

    var _loop4 = function _loop4(_i10) {
      plusButtons[_i10].addEventListener("click", function () {
        var plusButton = plusButtons[_i10];
        plusButton.parentNode.querySelector('[type=number]').stepUp();
        configPointsCalc();
        monitoringOfUsedPoints();
      });
    };

    for (var _i10 = 0; _i10 < plusButtons.length; _i10++) {
      _loop4(_i10);
    }
  } //function for removing point from input in configurator


  function removePoint() {
    var configuratiorSection = document.querySelector(".configurator-section");

    if (!configuratiorSection) {
      return;
    }

    var minusButtons = configuratiorSection.querySelectorAll(".features-list .feature-item .button-minus");

    var _loop5 = function _loop5(_i11) {
      minusButtons[_i11].addEventListener("click", function () {
        var minusButton = minusButtons[_i11];
        minusButton.parentNode.querySelector('[type=number]').stepDown();
        configPointsCalc();
        monitoringOfUsedPoints();
      });
    };

    for (var _i11 = 0; _i11 < minusButtons.length; _i11++) {
      _loop5(_i11);
    }
  } //function for check change on input


  function checkInputChange() {
    var configuratiorSection = document.querySelector(".configurator-section");

    if (!configuratiorSection) {
      return;
    }

    var featureItems = configuratiorSection.querySelectorAll(".features-list .feature-item input");

    for (var _i12 = 0; _i12 < featureItems.length; _i12++) {
      featureItems[_i12].addEventListener("change", function () {
        configPointsCalc();
        monitoringOfUsedPoints();
      });
    }
  } // function for count of points in configurator


  function configPointsCalc() {
    var configuratiorSection = document.querySelector(".configurator-section");
    var FeatureItems = configuratiorSection.querySelectorAll(".features-list .feature-item input");
    var totalPoins = configuratiorSection.querySelector(".total-used-points .total-points");
    var itemValueCount = 0;

    for (var _i13 = 0; _i13 < FeatureItems.length; _i13++) {
      var item = FeatureItems[_i13];
      var itemValue = parseInt(item.value);
      itemValueCount += itemValue;
    }

    totalPoins.textContent = itemValueCount;
    pointPriceCalc(itemValueCount);
  } //function for calc price of one point


  function pointPriceCalc(itemValueCount) {
    var configuratiorSection = document.querySelector(".configurator-section");
    var pointPriceResult = configuratiorSection.querySelector(".configurator-points-result .point-price");
    var data = dataBriloWeb;
    var basePrice = parseInt(data.calcValues.basePrice);
    var pointPrice = parseInt(data.calcValues.pointPrice);
    var result = basePrice / itemValueCount + pointPrice;
    result = Math.round(result);
    pointPriceResult.textContent = result;
    oneTimePaymentCalc(result, itemValueCount);
  } //function for calc one-time payment


  function oneTimePaymentCalc(result, itemValueCount) {
    var configuratiorSection = document.querySelector(".configurator-section");
    var oneTimePayment = configuratiorSection.querySelector(".one-time-payment");
    var oneTimePaymentCalc = result * itemValueCount;
    oneTimePayment.textContent = numberWithCommas(oneTimePaymentCalc);
  } // function for set different width of product item on mobile after click on label


  function widthAfterCheckInput() {
    var configuratorSection = document.querySelector(".configurator-section");

    if (!configuratorSection) {
      return;
    }

    var productItems = configuratorSection.querySelectorAll(".product-item");

    for (var _i14 = 0; _i14 < productItems.length; _i14++) {
      productItems[_i14].addEventListener("change", function () {
        var productItem = configuratorSection.querySelectorAll(".product-item");

        for (var j = 0; j < productItem.length; j++) {
          if (productItem[j].classList.contains("active-product-item")) {
            productItem[j].classList.remove("active-product-item");
          }
        }

        var checkedInput = configuratorSection.querySelector("input:checked");
        var checkedInputParent = checkedInput.parentNode;
        checkedInputParent.classList.add("active-product-item");
      }, {
        once: true
      });
    }

    return;
  } // function for set different width of product item on mobile


  function productItemWidth() {
    var configuratorSection = document.querySelector(".configurator-section");

    if (!configuratorSection) {
      return;
    }

    var productItem = configuratorSection.querySelectorAll(".product-item");

    for (var j = 0; j < productItem.length; j++) {
      if (productItem[j].classList.contains("active-product-item")) {
        productItem[j].classList.remove("active-product-item");
      }
    }

    var checkedInput = configuratorSection.querySelector("input:checked");
    var checkedInputParent = checkedInput.parentNode;
    checkedInputParent.classList.add("active-product-item");
    return;
  } //function for sticky right side of configurator


  function stickyConfigResultPosition() {
    var configRSide = document.querySelector(".configurator-section .configurator-right-side");

    if (!configRSide) {
      return;
    }

    var configSection = document.querySelector(".configurator-section");
    var configForm = document.querySelector(".configurator-section form");
    var configurator = document.querySelector(".configurator-section .configurator");
    var configLSide = document.querySelector(".configurator-section .features-block");
    var configuratorMarginTop = 32;
    var configuratorPaddingTop = 56;
    var configLSideOffset = configSection.offsetTop + configForm.offsetTop + configurator.offsetTop + (configuratorMarginTop * 5 + configuratorPaddingTop);
    var configLSideHeight = configLSide.offsetHeight;
    var configRSideHeight = configRSide.offsetHeight;
    var configLSideBottom = configLSideOffset + configLSideHeight;
    var scrolledFromTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop; //Scrolled From Top Plus Config Right Side Height

    var scrolledFTopPlusRSHeight = scrolledFromTop + configRSideHeight - configuratorPaddingTop - configuratorMarginTop; //Desktop - from from 992px  up

    if (window.matchMedia("(min-width: 62em)").matches) {
      if (scrolledFromTop >= configLSideOffset && scrolledFTopPlusRSHeight < configLSideBottom) {
        configRSide.classList.add("position-fixed");
      } else {
        configRSide.classList.remove("position-fixed");
      }

      if (scrolledFromTop >= configLSideBottom - configRSideHeight) {
        configRSide.classList.remove("position-fixed");
        configRSide.classList.add("m-top-auto");
      } else {
        configRSide.classList.remove("m-top-auto");
      }
    }

    var configFormOffsetTop = configSection.offsetTop + configForm.offsetTop;
    var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    var usedPointsHeight = configSection.querySelector(".total-used-points").offsetHeight;
    var onePointPriceHeight = configSection.querySelector(".one-point-price").offsetHeight;
    var totalPriceHeight = configSection.querySelector(".total-price").offsetHeight; //visible part of right  on mobile height + some spacings thats the magic number(space for plus)

    var visiblePartHeight = usedPointsHeight + onePointPriceHeight + totalPriceHeight + 16;
    var thirdOfPage = scrolledFromTop + viewportHeight / 2 * 2;
    var unvisiblePart = configRSideHeight - visiblePartHeight;
    var toTopButton = document.querySelector(".to-top-button"); //Up to tablet portrait - up to 991px

    if (window.matchMedia("(max-width: 61.938em)").matches) {
      if (scrolledFromTop >= configFormOffsetTop && thirdOfPage <= configLSideBottom) {
        configRSide.classList.add("position-fixed");
        scrollToFullTable();
        configRSide.style.bottom = -unvisiblePart + "px";
        configLSide.style.marginBottom = configRSideHeight + "px";
      } else {
        configLSide.style.marginBottom = "0px";
        configRSide.classList.remove("position-fixed");
        configRSide.style.bottom = "auto";
      }
    }

    var configSectionHeader = document.querySelector(".configurator-section header");
    var configSectionP = document.querySelector(".configurator-section header p");
    var configSectionPOffsetTop = configSection.offsetTop + configSectionHeader.offsetTop + configSectionP.offsetTop; //Phone portrait - up to 575px

    if (window.matchMedia("(max-width: 35.938em)").matches) {
      if (scrolledFromTop >= configSectionPOffsetTop && thirdOfPage <= configLSideBottom) {
        configRSide.classList.add("position-fixed");
        scrollToFullTable();
        configRSide.style.bottom = -unvisiblePart + "px";
        configLSide.style.marginBottom = configRSideHeight + "px";
      } else {
        configLSide.style.marginBottom = "0px";
        configRSide.classList.remove("position-fixed");
        configRSide.style.bottom = "auto";
      }
    }
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  } //function for scroll to full table


  function scrollToFullTable() {
    var configuratiorSection = document.querySelector(".configurator-section");

    if (!configuratiorSection) {
      return;
    }

    var configSection = document.querySelector(".configurator-section");
    var configForm = document.querySelector(".configurator-section form");
    var configurator = document.querySelector(".configurator-section .configurator");
    var configLSide = document.querySelector(".configurator-section .features-block");
    var configLSideOffset = configSection.offsetTop + configForm.offsetTop + configurator.offsetTop;
    var configLSideHeight = configLSide.offsetHeight;
    var configLSideBottom = configLSideOffset + configLSideHeight;
    var totalPrice = configuratiorSection.querySelector(".total-price");
    totalPrice.addEventListener("click", function () {
      var isIE = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;

      if (isIE) {
        window.scrollTo(0, configLSideBottom);
      } else {
        window.scroll({
          top: configLSideBottom,
          left: 0,
          behavior: 'smooth'
        });
      }
    });
  } //function for open popup


  function openPopUp(labelCheckedID) {
    var configuratiorSection = document.querySelector(".configurator-section");
    var popUp = configuratiorSection.querySelector(".configurator-control-popup");
    popUp.classList.add("configurator-control-popup-visible");
    var labelChecked = labelCheckedID;
    popUpResult(labelChecked);
  } //function for close popup


  function closePopUp() {
    var configuratiorSection = document.querySelector(".configurator-section");
    var popUp = configuratiorSection.querySelector(".configurator-control-popup");
    popUp.classList.remove("configurator-control-popup-visible");
    return;
  } //function for check conformity


  function checkConformity(checkedInputID, labelchecked) {
    var configuratiorSection = document.querySelector(".configurator-section");
    var previewCheckedInputID = checkedInputID;
    var labelCheckedID = labelchecked;
    var data = dataBriloWeb;
    var previewItemsVariables = data[previewCheckedInputID];
    var previewItems = configuratiorSection.querySelectorAll(".features-list .feature-item input");
    var result = false;

    for (var _i15 = 0; _i15 < previewItems.length; _i15++) {
      if (previewItems[_i15].value !== previewItemsVariables[_i15]) {
        result = true;
      }
    }

    if (result === true) {
      openPopUp(labelCheckedID);
    } else {
      //nastav hodnoty dle  dat
      var actualItemsVariables = data[labelCheckedID];
      var actualItems = configuratiorSection.querySelectorAll(".features-list .feature-item input");

      for (var _i16 = 0; _i16 < actualItems.length; _i16++) {
        actualItems[_i16].value = actualItemsVariables[_i16];
      }

      configPointsCalc(); //Up to tablet portrait - up to 991px

      if (window.matchMedia("(max-width: 61.938em)").matches) {
        productItemWidth();
      }
    }
  }

  function popUpResult(labelCheckedID) {
    var configuratiorSection = document.querySelector(".configurator-section");
    var button = configuratiorSection.querySelector(".configurator-control-popup .btn");
    var cross = configuratiorSection.querySelector(".configurator-control-popup .cross");
    var controlPopUp = configuratiorSection.querySelector(".configurator-control-popup .control-popup");
    var popUp = configuratiorSection.querySelector(".configurator-control-popup");
    var labelChecked = labelCheckedID;
    var data = dataBriloWeb;
    popUp.addEventListener("click", function (e) {
      if (e.target === button) {
        closePopUp();
        configuratiorSection.querySelector("#" + labelChecked).checked = true;
        var actualItemsVariables = data[labelCheckedID];
        var actualItems = configuratiorSection.querySelectorAll(".features-list .feature-item input");

        for (var _i17 = 0; _i17 < actualItems.length; _i17++) {
          actualItems[_i17].value = actualItemsVariables[_i17];
        }

        configPointsCalc(); //Up to tablet portrait - up to 991px

        if (window.matchMedia("(max-width: 61.938em)").matches) {
          productItemWidth();
        }
      } else {
        if (e.target !== controlPopUp || e.target === cross) {
          closePopUp();
        }
      }
    }, {
      once: true
    });
    return;
  }
})();

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    domainPerex();
    scrollTrigger();
  });

  function domainPerex() {
    var labels = document.querySelectorAll(".domain-form-section .input-block-top label");
    var i;

    for (i = 0; i < labels.length; i++) {
      labels[i].addEventListener("click", function () {
        var domainPerexs = document.querySelectorAll(".domain-form-section .domain-perex p");

        for (i = 0; i < domainPerexs.length; i++) {
          domainPerexs[i].classList.add("js-disabled");
        }

        var perexId = this.getAttribute("data-id-perex");
        var domainPerex = document.querySelector("#" + perexId);

        if (domainPerex.classList.contains("js-disabled")) {
          domainPerex.classList.remove("js-disabled");
        }
      });
    }
  }

  function scrollTrigger() {
    var scrollTrigger = document.querySelectorAll(".scroll-trigger");
    var i; // Button--------------

    for (i = 0; i < scrollTrigger.length; i++) {
      scrollTrigger[i].addEventListener("click", function () {
        var sectionId = this.getAttribute("data-id-section");
        var topOfSection = document.querySelector("#" + sectionId);
        var topOfSectionPx = topOfSection.offsetTop;
        var isIE = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;

        if (isIE) {
          window.scrollTo(0, topOfSectionPx);
        } else {
          topOfSection.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      });
    }
  }
})(); // Document ready


document.addEventListener("DOMContentLoaded", function () {
  tablesStyleCorrection();
  videoIframeWrap();
}); //Tables style correction

function tablesStyleCorrection() {
  removeWidthHeight(".entry-content table");
  removeWidthHeight(".entry-content tr");
  removeWidthHeight(".entry-content th");
  removeWidthHeight(".entry-content td");
} //Remove width and height inline style


function removeWidthHeight(selector) {
  var correctedElement = document.querySelectorAll(selector),
      i;

  for (i = 0; i < correctedElement.length; ++i) {
    if (correctedElement[i].style.removeProperty) {
      correctedElement[i].style.removeProperty("width");
    } else {
      correctedElement[i].style.removeAttribute("width");
    }

    if (correctedElement[i].style.removeProperty) {
      correctedElement[i].style.removeProperty("height");
    } else {
      correctedElement[i].style.removeAttribute("height");
    }
  }
} //Video iframe wrap


function videoIframeWrap() {
  var contentIframes = document.querySelectorAll(".entry-content iframe"),
      i;

  for (i = 0; i < contentIframes.length; ++i) {
    var itemSrc = contentIframes[i].getAttribute("src");

    if (itemSrc.indexOf("youtube") != -1) {
      contentIframes[i].classList.add("embed-responsive-item");
      contentIframes[i].removeAttribute("height");
      contentIframes[i].removeAttribute("width");
      var iframeWrap = document.createElement("div");
      iframeWrap.classList.add("embed-responsive", "embed-responsive-16by9");
      contentIframes[i].parentNode.insertBefore(iframeWrap, contentIframes[i]);
      iframeWrap.appendChild(contentIframes[i]);
    }
  }
} // $(function () {
//     $('[data-toggle="tooltip"]').tooltip({
//         trigger: "click"
//     });
// });
// $(document).on('click','.tooltip-close',function(){
//     $('[data-toggle="tooltip"]').tooltip('hide');
// });


(function () {
  document.addEventListener("DOMContentLoaded", function () {
    tableHeaderPosition();
    window.addEventListener('resize', function () {
      tableHeaderPosition();
      window.addEventListener('scroll', function () {
        stickyTableHeadPosition();
      });
    });
    window.addEventListener('scroll', function () {
      stickyTableHeadPosition();
    }); //Phone portrait - up to 575px

    if (window.matchMedia("(max-width: 35.938em)").matches) {
      packageSwipe();
      tableHeaderPosition();
      window.addEventListener('scroll', function () {
        stickyTableHeadPosition();
      });
      window.addEventListener('resize', function () {
        packageSwipe();
        tableHeaderPosition();
        stickyTableHeadPosition();
        window.addEventListener('scroll', function () {
          stickyTableHeadPosition();
        });
      });
    }
  }); //function for sticky table header

  function stickyTableHeadPosition() {
    var table = document.querySelector(".function-section table");

    if (!table) {
      return;
    }

    var tableOffset = table.offsetTop;
    var tableHead = document.querySelector(".fake-table-head");
    var tableHeadHeight = tableHead.offsetHeight;
    var tableTop = tableOffset - tableHeadHeight;
    var tableHeight = table.offsetHeight;
    var tableBottom = tableHeight + tableTop;
    var scrolledFromTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

    if (scrolledFromTop >= tableTop && tableBottom >= scrolledFromTop) {
      tableHead.classList.remove("position-absolute");
      tableHead.style.top = 0 + "px";
    } else {
      tableHead.classList.add("position-absolute");
      tableHeaderPosition();
    }
  } // Table header position


  function tableHeaderPosition() {
    var table = document.querySelector(".function-section table");

    if (!table) {
      return;
    }

    var tableOffset = table.offsetTop;
    var tableHead = document.querySelector(".fake-table-head");
    var tableHeadHeight = tableHead.offsetHeight;
    tableHead.style.top = tableOffset - tableHeadHeight + "px";
  } // PackageSwipe


  function packageSwipe() {
    // columns
    var firstPackage = document.querySelectorAll("tbody tr td:nth-child(2)");
    var secondPackage = document.querySelectorAll("tbody tr td:nth-child(3)");
    var thirdPackage = document.querySelectorAll("tbody tr td:nth-child(4)"); //buttons

    var firstBtn = document.querySelector("tfoot tr td:first-child");
    var secondBtn = document.querySelector("tfoot tr td:nth-child(2)");
    var thirdBtn = document.querySelector("tfoot tr td:nth-child(3)"); //logos

    var fakeFirstLogo = document.querySelector(".fake-table-head div:nth-child(2)");
    var fakeSecondLogo = document.querySelector(".fake-table-head div:nth-child(3)");
    var fakeThirdLogo = document.querySelector(".fake-table-head div:nth-child(4)"); //arrows

    var arrows = document.querySelectorAll(".fake-table-head .arrow");
    var arrowLeft = document.querySelector(".fake-table-head .arrow-left");
    var arrowRight = document.querySelector(".fake-table-head .arrow-right"); // initial constant //initial package, second = 2

    var number = 2;

    var _loop6 = function _loop6(_i18) {
      arrows[_i18].addEventListener("click", function () {
        var arrowClicked = arrows[_i18]; //swipe to left

        if (arrowClicked.classList.contains("arrow-left")) {
          var arrowNumber = -1;
          number = number + arrowNumber;

          if (number === 1) {
            arrowLeft.classList.add("disabled");
            noPackageNumber = secondPackage;
            noFakeLogo = fakeSecondLogo;
            noButton = secondBtn;
            packageHideRight(noPackageNumber, noFakeLogo, noButton);
            packageNumber = firstPackage;
            fakeLogo = fakeFirstLogo;
            button = firstBtn;
            packageDisplayLeft(packageNumber, fakeLogo, button);
          } else {
            //for info...number===2
            arrowRight.classList.remove("disabled");
            arrowLeft.classList.remove("disabled");
            noPackageNumber = thirdPackage;
            noFakeLogo = fakeThirdLogo;
            noButton = thirdBtn;
            packageHideRight(noPackageNumber, noFakeLogo, noButton);
            packageNumber = secondPackage;
            fakeLogo = fakeSecondLogo;
            button = secondBtn;
            packageDisplayLeft(packageNumber, fakeLogo, button);
          } //swipe to right

        } else {
          var _arrowNumber = 1;
          number = number + _arrowNumber;

          if (number === 3) {
            arrowRight.classList.add("disabled");
            noPackageNumber = secondPackage;
            noFakeLogo = fakeSecondLogo;
            noButton = secondBtn;
            packageHideLeft(noPackageNumber, noFakeLogo, noButton);
            packageNumber = thirdPackage;
            fakeLogo = fakeThirdLogo;
            button = thirdBtn;
            packageDisplayRight(packageNumber, fakeLogo, button);
          } else {
            //for info...number===2
            arrowRight.classList.remove("disabled");
            arrowLeft.classList.remove("disabled");
            noPackageNumber = firstPackage;
            noFakeLogo = fakeFirstLogo;
            noButton = firstBtn;
            packageHideLeft(noPackageNumber, noFakeLogo, noButton);
            packageNumber = secondPackage;
            fakeLogo = fakeSecondLogo;
            button = secondBtn;
            packageDisplayRight(packageNumber, fakeLogo, button);
          }
        }
      });
    };

    for (var _i18 = 0; _i18 < arrows.length; _i18++) {
      _loop6(_i18);
    }
  } // Hide right package


  function packageHideRight(noPackageNumber, noFakeLogo, noButton) {
    noFakeLogo.classList.remove("transform-right");
    noFakeLogo.classList.remove("transform-left");

    if (noFakeLogo.classList.contains("transform-mid")) {
      noFakeLogo.classList.remove("transform-mid");
    }

    noFakeLogo.classList.add("hide-right");

    for (var _i19 = 0; _i19 < noPackageNumber.length; _i19++) {
      noPackageNumber[_i19].classList.add("display-none");
    }

    noButton.classList.add("display-none");
  }

  function packageHideLeft(noPackageNumber, noFakeLogo, noButton) {
    noFakeLogo.classList.remove("transform-right");
    noFakeLogo.classList.remove("transform-left");

    if (noFakeLogo.classList.contains("transform-mid")) {
      noFakeLogo.classList.remove("transform-mid");
    }

    noFakeLogo.classList.add("hide-left");

    for (var _i20 = 0; _i20 < noPackageNumber.length; _i20++) {
      noPackageNumber[_i20].classList.add("display-none");
    }

    noButton.classList.add("display-none");
  }

  function packageDisplayRight(packageNumber, fakeLogo, button) {
    for (i = 0; i < packageNumber.length; i++) {
      packageNumber[i].classList.remove("display-none");
    }

    fakeLogo.classList.remove("hide-left");
    fakeLogo.classList.remove("hide-right");
    fakeLogo.classList.add("transform-right");
    button.classList.remove("display-none");
  }

  function packageDisplayLeft(packageNumber, fakeLogo, button) {
    for (i = 0; i < packageNumber.length; i++) {
      packageNumber[i].classList.remove("display-none");
    }

    fakeLogo.classList.remove("hide-right");
    fakeLogo.classList.remove("hide-left");
    fakeLogo.classList.add("transform-left");
    button.classList.remove("display-none");
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  featureScroll();
}); //featureScroll ----------------------------------

function featureScroll() {
  var featureButton = document.querySelector(".feature-button");

  if (!featureButton) {
    return;
  }

  var featureSection = document.querySelector(".feature-section");

  if (featureButton != null) {
    featureButton.addEventListener("click", function () {
      featureSection.scrollIntoView({
        behavior: "smooth"
      });
    });
  }
}

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    assigneeFiltration();
  });

  function assigneeFiltration() {
    var makingProcessSection = document.querySelector(".making-process-section");

    if (!makingProcessSection) {
      return;
    }

    var filtrationItem = makingProcessSection.querySelectorAll(".assignee-filtration-item");

    var _loop7 = function _loop7(_i21) {
      filtrationItem[_i21].addEventListener("click", function () {
        var selectedFilter = filtrationItem[_i21];

        if (selectedFilter.classList.contains("client-assignee")) {
          unselectedBrilo();
          selectedClient(makingProcessSection, selectedFilter); //Phone portrait - up to 575px

          if (window.matchMedia("(max-width: 35.938em)").matches) {
            var disabled = document.querySelector(".making-process-assignee-filtration .brilo-assignee");
            disabledFilter(disabled);
          }
        } else {
          unselectedClient();
          selectedBrilo(makingProcessSection, selectedFilter); //Phone portrait - up to 575px

          if (window.matchMedia("(max-width: 35.938em)").matches) {
            var _disabled = document.querySelector(".making-process-assignee-filtration .client-assignee");

            disabledFilter(_disabled);
          }
        }
      });
    };

    for (var _i21 = 0; _i21 < filtrationItem.length; _i21++) {
      _loop7(_i21);
    }
  } // selected client assignee


  function selectedClient(makingProcessSection, selectedFilter) {
    selectedFilter.classList.toggle("assignee-selected");
    var briloAssignee = makingProcessSection.querySelectorAll(".row .asignee-brilo");

    for (var j = 0; j < briloAssignee.length; j++) {
      var assignee = briloAssignee[j];
      assignee.classList.toggle("unselected-assignee");

      if (assignee.classList.contains("asignee-both")) {
        assignee.classList.remove("unselected-assignee");
        assignee.querySelector(".assigneed-to-brilo").classList.toggle("asignee-half");
      }
    }
  } // remove client assignee


  function unselectedClient() {
    var makingProcessSection = document.querySelector(".making-process-section");

    if (!makingProcessSection) {
      return;
    }

    var client = makingProcessSection.querySelector(".client-assignee");

    if (client.classList.contains("assignee-selected")) {
      var selectedFilter = makingProcessSection.querySelector(".client-assignee");
      selectedFilter.classList.toggle("assignee-selected");
      var briloAssignee = makingProcessSection.querySelectorAll(".row .asignee-brilo");

      for (var j = 0; j < briloAssignee.length; j++) {
        var assignee = briloAssignee[j];
        assignee.classList.toggle("unselected-assignee");

        if (assignee.classList.contains("asignee-both")) {
          assignee.classList.remove("unselected-assignee");
          assignee.querySelector(".assigneed-to-brilo").classList.toggle("asignee-half");
        }
      }
    }
  } // selected brilo assignee


  function selectedBrilo(makingProcessSection, selectedFilter) {
    selectedFilter.classList.toggle("assignee-selected");
    var clientAssignee = makingProcessSection.querySelectorAll(".row .asignee-client");

    for (var j = 0; j < clientAssignee.length; j++) {
      var assignee = clientAssignee[j];
      assignee.classList.toggle("unselected-assignee");

      if (assignee.classList.contains("asignee-both")) {
        assignee.classList.remove("unselected-assignee");
        assignee.querySelector(".assigneed-to-client").classList.toggle("asignee-half");
      }
    }
  } // remove brilo assignee


  function unselectedBrilo() {
    var makingProcessSection = document.querySelector(".making-process-section");

    if (!makingProcessSection) {
      return;
    }

    var brilo = makingProcessSection.querySelector(".brilo-assignee");

    if (brilo.classList.contains("assignee-selected")) {
      var selectedFilter = makingProcessSection.querySelector(".brilo-assignee");
      selectedFilter.classList.toggle("assignee-selected");
      var clientAssignee = makingProcessSection.querySelectorAll(".row .asignee-client");

      for (var j = 0; j < clientAssignee.length; j++) {
        var assignee = clientAssignee[j];
        assignee.classList.toggle("unselected-assignee");

        if (assignee.classList.contains("asignee-both")) {
          assignee.classList.remove("unselected-assignee");
          assignee.querySelector(".assigneed-to-client").classList.toggle("asignee-half");
        }
      }
    }
  }

  function disabledFilter(disabled) {
    var makingProcessSection = document.querySelector(".making-process-section");
    var brilo = document.querySelector(".making-process-assignee-filtration .brilo-assignee");
    var client = document.querySelector(".making-process-assignee-filtration .client-assignee");

    if (disabled === brilo) {
      if (client.classList.contains("disabled-filter")) {
        client.classList.remove("disabled-filter");
      }
    } else {
      if (brilo.classList.contains("disabled-filter")) {
        brilo.classList.remove("disabled-filter");
      }
    }

    disabled.classList.toggle("disabled-filter");
  }
})();

(function () {
  // Document ready
  document.addEventListener("DOMContentLoaded", function () {
    tableCalc();
  });

  function tableCalc() {
    //Package
    var packageType = document.querySelector(".order-summary-section .package");

    if (!packageType) {
      return;
    }

    var packagePrice = packageType.parentNode.querySelector(" .price .price-box").textContent;
    packagePrice = packagePrice.replace(/\s/g, '');
    packagePrice = parseInt(packagePrice);
    var packagePriceDPH = packageType.parentNode.querySelector(" .price-width-dph .price-box").textContent;
    packagePriceDPH = packagePriceDPH.replace(/\s/g, '');
    packagePriceDPH = parseInt(packagePriceDPH); //Duration

    var durationPrice = document.querySelector(".order-summary-section .package-duration-box .price .price-box").textContent;
    durationPrice = durationPrice.replace(/\s/g, '');
    durationPrice = parseInt(durationPrice);
    var durationPriceDPH = document.querySelector(".order-summary-section .package-duration-box .price-width-dph .price-box").textContent;
    durationPriceDPH = durationPriceDPH.replace(/\s/g, '');
    durationPriceDPH = parseInt(durationPriceDPH); //Total price

    var totalPriceLocation = document.querySelector(".order-summary-section .total-price .price .price-box");
    var totalPriceLocationDPH = document.querySelector(".order-summary-section .total-price .price-width-dph .price-box");
    var totalPrice = packagePrice + durationPrice;
    var totalPriceDPH = packagePriceDPH + durationPriceDPH;
    var totalPriceText = numberWithSpaces(totalPrice);
    var totalPriceDPHText = numberWithSpaces(totalPriceDPH);
    totalPriceLocation.innerHTML = numberWithSpaces(totalPrice);
    totalPriceLocationDPH.innerHTML = numberWithSpaces(totalPriceDPH); // Total price input

    document.querySelector("#totalPrice").value = "";
    document.querySelector("#totalPrice").value += totalPriceText + "Kč" + ";" + totalPriceDPHText + "Kč";
  }

  function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
})();

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    headrommInit();
    headerNavButtonClick();
    headerMaskClick();
    desktopSubmenu();
    mobileSubmenuInit();
    mobileSubmenu();
    headerSearch();
    headerLang();
  });

  function headrommInit() {
    // select your header or whatever element you wish
    var header = document.querySelector(".header-main");
    var options = {
      // vertical offset in px before element is first unpinned
      offset: 0
    };
    var headroom = new Headroom(header, options);
    headroom.init();
  }

  ; //Resize

  window.addEventListener("resize", function () {
    if (window.matchMedia("(min-width: 62em)").matches) {
      var navMain = document.querySelector(".nav-main");

      if (navMain.classList.contains("js-transition")) {
        navMain.classList.remove("js-transition");
        headerMaskHide();
        headerNavHide();
      }
    }

    if (window.matchMedia("(min-width: 36em)").matches) {
      var headerSearchInner = document.querySelector(".header-search-inner");

      if (!headerSearchInner) {
        return;
      }

      if (headerSearchInner.classList.contains("js-search-open")) {
        headerSearchClose();
        headerMaskHide();
      }
    }
  }); //Header nav

  function headerNavButtonClick() {
    var navMain = document.querySelector(".nav-main");
    var headerNavButton = document.querySelector(".header-nav-button");
    headerNavButton.addEventListener("click", function () {
      if (!navMain.classList.contains("js-open")) {
        headerNavShow();
        headerMaskShow();
      } else {
        headerNavHide();
        headerMaskHide();
      }

      if (!navMain.classList.contains("js-transition")) {
        navMain.classList.add("js-transition");
      }
    });
  }

  function headerNavShow() {
    var navMain = document.querySelector(".nav-main");
    var headerNavButton = document.querySelector(".header-nav-button");
    var body = document.querySelector("body");
    var html = document.querySelector("html");
    navMain.classList.add("js-open");
    headerNavButton.classList.add("js-open");
    body.classList.add("js-no-scroll");
    html.classList.add("js-no-scroll");
  }

  function headerNavHide() {
    var navMain = document.querySelector(".nav-main");
    var headerNavButton = document.querySelector(".header-nav-button");
    var body = document.querySelector("body");
    var html = document.querySelector("html");
    navMain.classList.remove("js-open");
    headerNavButton.classList.remove("js-open");
    body.classList.remove("js-no-scroll");
    html.classList.remove("js-no-scroll");

    if (window.matchMedia("(max-width: 61.938em)").matches) {} //Sub menu close


    var subMenuButtons = document.querySelectorAll(".sub-menu-button");

    if (subMenuButtons) {
      for (var _i22 = 0; _i22 < subMenuButtons.length; _i22++) {
        if (subMenuButtons[_i22].classList.contains("js-open")) {
          subMenuButtons[_i22].classList.remove("js-open");
        }

        subMenuButtons[_i22].parentNode.classList.remove("js-open");

        if (subMenuButtons[_i22].parentNode.classList.contains("js-open")) {
          subMenuButtons[_i22].parentNode.querySelector(".sub-menu").classList.remove("js-open");
        }
      }
    }

    if (navMain.querySelector(".sub-menu")) {
      navMain.querySelector(".sub-menu").classList.remove("js-open");
    }
  } //Header Mask


  function headerMaskClick() {
    var headerMask = document.querySelector(".header-mask");
    headerMask.addEventListener("click", function () {
      headerNavHide();
      headerMaskHide();
    });
  }

  function headerMaskShow() {
    var headerMask = document.querySelector(".header-mask");
    headerMask.classList.add("js-active");
  }

  function headerMaskHide() {
    var headerMask = document.querySelector(".header-mask");
    headerMask.classList.remove("js-active");
  } //Desktop submenu


  function desktopSubmenu() {
    if (window.matchMedia("(min-width: 62em)").matches) {
      (function () {
        var subMenuItemHasChildren = document.querySelectorAll(".sub-menu .menu-item-has-children");

        var _loop8 = function _loop8(_i23) {
          subMenuItemHasChildren[_i23].addEventListener("mouseover", function () {
            var subSubMenu = subMenuItemHasChildren[_i23].querySelector(".sub-menu");

            var leftOffset = subSubMenu.getBoundingClientRect().left;
            var elWidht = subSubMenu.offsetWidth;

            if (window.innerWidth <= leftOffset + elWidht + 5) {
              subSubMenu.classList.add("js-sub-menu-left");
            }
          });
        };

        for (var _i23 = 0; _i23 < subMenuItemHasChildren.length; _i23++) {
          _loop8(_i23);
        }
      })();
    }
  } //Mobile submenu init


  function mobileSubmenuInit() {
    var menuItemHasChildren = document.querySelectorAll(".menu-item-has-children");

    for (var _i24 = 0; _i24 < menuItemHasChildren.length; _i24++) {
      menuItemHasChildren[_i24].insertAdjacentHTML('beforeend', '<span class="sub-menu-button"></span>');
    }
  } //Mobile submenu


  function mobileSubmenu() {
    var subMenuButtons = document.querySelectorAll(".sub-menu-button");

    var _loop9 = function _loop9(_i25) {
      subMenuButtons[_i25].addEventListener("click", function () {
        var item = subMenuButtons[_i25];

        if (!item.classList.contains("js-open")) {
          item.classList.add("js-open");
          item.parentNode.classList.add("js-open");
          item.parentNode.querySelector(".sub-menu").classList.add("js-open");
        } else {
          item.classList.remove("js-open");
          item.parentNode.classList.remove("js-open");
          item.parentNode.querySelector(".sub-menu").classList.remove("js-open");

          if (item.parentNode.querySelector(".sub-menu .sub-menu")) {
            item.parentNode.querySelector(".sub-menu .sub-menu").classList.remove("js-open");
          }
        }
      });
    };

    for (var _i25 = 0; _i25 < subMenuButtons.length; _i25++) {
      _loop9(_i25);
    }
  } //Header lang


  function headerLang() {
    var langCurrent = document.querySelector(".header-language-current");

    if (!langCurrent) {
      return;
    }

    var langList = document.querySelector(".header-language-list");
    var otherElements = document.querySelector(".header-language-switcher *");
    langCurrent.addEventListener("click", function () {
      langList.classList.toggle("js-open");
    }); //Close

    document.addEventListener("click", function (e) {
      if (otherElements !== e.target && langList !== e.target && langList.classList.contains("js-open")) {
        langList.classList.remove("js-open");
      }

      ;
    });
  } //Header search  -------------------not completed


  function headerSearch() {
    var headerSearchBtn = document.querySelector(".header-search-button");

    if (!headerSearchBtn) {
      return;
    }

    var headerSearchInner = document.querySelector(".header-search-inner");
    headerSearchBtn.addEventListener("click", function () {
      if (!headerSearchInner.classList.contains("js-search-open")) {
        headerSearchOpen();
      } else {
        headerSearchClose();
        headerMaskHide();
      }
    }); //Close

    document.addEventListener("click", function (e) {
      if (!headerSearchInner.contains(e.target) && !headerSearchBtn.contains(e.target)) {
        if (headerSearchInner.classList.contains("js-search-open")) {
          headerSearchClose();
        }
      }

      ;
    });
  }

  function headerSearchOpen() {
    var headerSearchInner = document.querySelector(".header-search-inner");
    var headerSearchInput = document.querySelector(".header-search-input");
    var body = document.querySelector("body");
    var html = document.querySelector("html");
    headerSearchInner.classList.add("js-search-open");
    headerSearchInput.focus();

    if (window.matchMedia("(max-width: 35.938em)").matches) {
      headerMaskShow();
      body.classList.add("js-no-scroll");
      html.classList.add("js-no-scroll");
    }

    headerSearchInner.classList.add("js-animate");
  }

  function headerSearchClose() {
    var headerSearchInner = document.querySelector(".header-search-inner");
    var headerSearchInput = document.querySelector(".header-search-input");
    var body = document.querySelector("body");
    var html = document.querySelector("html");
    headerSearchInner.classList.remove("js-animate");
    headerSearchInner.classList.remove("js-search-open");
    headerSearchInput.value = '';
    body.classList.remove("js-no-scroll");
    html.classList.remove("js-no-scroll");
  }
})();

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    SliderCoopInit();
  }); //Coop slider init

  function SliderCoopInit() {
    if (!document.querySelector(".slider-feedback-section")) {
      return;
    }

    var slider = tns({
      container: '.slider-feedback',
      loop: false,
      autoplay: false,
      arrows: true,
      mouseDrag: true,
      controls: true,
      nav: false,
      responsive: {
        1200: {
          items: 4
        },
        991: {
          items: 3
        },
        576: {
          items: 2
        }
      }
    });
  }
})(); // $(function () {
//   console.log("done")
//   $('.test-result-item .result-title').matchHeight();
// });
// Document ready


document.addEventListener("DOMContentLoaded", function () {
  checkInit();
});

function checkInit() {
  var check = setInterval(ifIsLoaded, 2000);

  function ifIsLoaded() {
    var circle = document.querySelector(".thanks-section .white-circle");

    if (!circle) {
      return;
    }

    var diamond = document.querySelector(".thanks-section .diamond-finish-img img");

    if (diamond.classList.contains("loaded")) {
      circle.classList.add("checkbox-animation");
      stopInterval();
    }
  }

  function stopInterval() {
    clearInterval(check);
  }
}
//# sourceMappingURL=functions.js.map
